<template>
  <div class="tab_company_out">
    <div v-for="(pageData, index) in printDataList" :key="index">
      <h2 style="text-align: center">{{ pageData.settlementCompanyName }}</h2>
      <div class="row" style="justify-content: center; position: relative">
        <h4>收费通知单</h4>
        <span style="position: absolute; right: 10px"
          >单号:{{ pageData.receivableSettlementNo }}</span
        >
      </div>
      <div class="row" style="justify-content: space-between; padding-right: 10px">
        <div class="customer">单位名称:{{ pageData.customerName }}</div>
        <div class="time">
          单位:元
          <span style="margin-left: 30px">{{ pageData.settlementCreateDate.substring(0, 7) }}</span>
        </div>
      </div>
      <table class="table1" cellpadding="0" cellspacing="0">
        <tr>
          <th>收费项目</th>
          <th>金额</th>
          <th>吨位</th>
          <th>单价</th>
          <th>收费项目</th>
          <th>金额</th>
          <th>吨位</th>
          <th>单价</th>
        </tr>
        <tr>
          <td>1.{{ findDataByTitle('调拨单费用', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('调拨单费用', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('调拨单费用', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('调拨单费用', pageData.warehouseItems)?.price }}</td>
          <td>8.{{ findDataByTitle('转库费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('转库费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('转库费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('转库费', pageData.warehouseItems)?.price }}</td>
        </tr>
        <tr>
          <td>2.{{ findDataByTitle('对外调度费用', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('对外调度费用', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('对外调度费用', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('对外调度费用', pageData.warehouseItems)?.price }}</td>
          <td>9.{{ findDataByTitle('站台费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('站台费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('站台费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('站台费', pageData.warehouseItems)?.price }}</td>
        </tr>
        <tr>
          <td>3.{{ findDataByTitle('上磅费用', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('上磅费用', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('上磅费用', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('上磅费用', pageData.warehouseItems)?.price }}</td>
          <td>10.{{ findDataByTitle('超期费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('超期费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('超期费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('超期费', pageData.warehouseItems)?.price }}</td>
        </tr>
        <tr>
          <td>4.{{ findDataByTitle('汽车入库费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('汽车入库费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('汽车入库费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('汽车入库费', pageData.warehouseItems)?.price }}</td>
          <td>11.{{ findDataByTitle('质押监管', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('质押监管', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('质押监管', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('质押监管', pageData.warehouseItems)?.price }}</td>
        </tr>
        <tr>
          <td>5.{{ findDataByTitle('专线入库费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('专线入库费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('专线入库费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('专线入库费', pageData.warehouseItems)?.price }}</td>
          <td>12.{{ findDataByTitle('运输费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('运输费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('运输费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('运输费', pageData.warehouseItems)?.price }}</td>
        </tr>
        <tr>
          <td>6.{{ findDataByTitle('专线出库费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('专线出库费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('专线出库费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('专线出库费', pageData.warehouseItems)?.price }}</td>
          <td>13.{{ findDataByTitle('加工费', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('加工费', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('加工费', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('加工费', pageData.warehouseItems)?.price }}</td>
        </tr>
        <tr>
          <td>7.{{ findDataByTitle('专线直调费用', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('专线直调费用', pageData.warehouseItems)?.amount }}</td>
          <td>{{ findDataByTitle('专线直调费用', pageData.warehouseItems)?.num }}</td>
          <td>{{ findDataByTitle('专线直调费用', pageData.warehouseItems)?.price }}</td>
          <td>{{ findDataByTitle('费用合计', pageData.warehouseItems)?.expenseTypeName }}</td>
          <td>{{ findDataByTitle('费用合计', pageData.warehouseItems)?.amount }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr rowspan="3">
          <td colspan="8">
            <div
              >单位名称:{{ pageData.settlementCompanyName }} &nbsp;&nbsp;开户行:{{
                pageData.branchName
              }}</div
            >
            <div
              >账号:{{ pageData.bankAccountNum }}&nbsp;&nbsp;金额:{{
                findDataByTitle('费用合计', pageData.warehouseItems)?.amount
              }}</div
            >
          </td>
        </tr>
        <tr rowspan="3">
          <td colspan="8">
            <div
              >请按上面"截止本期未付款金额累计"的金额在本月20日前安排转款，超过20日将委托单规定抽取违约金(违约金按欠款总额每日千分之三的比例计算)，同时取消签单权</div
            >
          </td>
        </tr>
        <tr rowspan="8">
          <td colspan="8" style="padding: 0">
            <div style="display: flex; flex-direction: row">
              <div
                class="font12"
                style="width: 100px; height: 22px; border-right: 1px solid #000; padding: 5px"
                >备注</div
              >
              <!-- <div style="padding: 5px">结算日期:{{ pageData.settlementDate }}</div> -->
              <div style="padding: 5px"
                >费用结算期:{{
                  (pageData.periodDateFrom ? pageData.periodDateFrom : '') +
                  ' 至 ' +
                  (pageData.periodDateUntil ? pageData.periodDateUntil : '')
                }}</div
              >
            </div>
          </td>
        </tr>
      </table>
      <div class="row" style="justify-content: space-between">
        <div class="mobile font12">结算中心:07722567630</div>
        <div class="date font12">制单时间:{{ pageData.settlementCreateDate }}</div>
        <div class="person font12">制单人:{{ pageData.salesmanName }}</div>
      </div>
      <div class="row font12" style="justify-content: center; margin: 30px 50px">
        {{ pageData.settlementCompanyName }}(盖章)
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PrintFile',
    props: {
      // 传递打印的ids
      printIdList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        printDataList: [],
        warehouseItems: [],
      };
    },
    created() {
      //动态添加自定义字体样式
      let style = document.createElement('style');
      style.type = 'text/css';
      style.innerText =
        "@font-face {font-family:'PingFang-Regular';src:url('https://diary-biku.oss-cn-qingdao.aliyuncs.com/upload_file/common/typeface/2557240976048193.ttf')}";
      document.getElementsByTagName('head')[0].appendChild(style);
    },

    mounted() {
      this.getPrintData(this.printIdList);
    },
    methods: {
      async getPrintData(printIdList) {
        const { data } = await this.$axios.post(`/financial/receivableSettlement/listForPrint`, {
          ids: printIdList,
        });
        if (data.code == 0) {
          this.printDataList = data.data;
        } else {
          console.log('获取数据失败');
        }
      },
      findDataByTitle(title, warehouseItems = []) {
        // console.log("转库费",title,warehouseItems)
        if (warehouseItems.length) {
          const row = warehouseItems.find((item) => item.expenseTypeName == title);
          row.num = row.num ? parseFloat(row.num).toFixed(3) : row.num;
          return row;
        } else {
          return {
            expenseTypeName: '',
            price: 0,
            num: 0,
            amount: 0,
          };
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tab_company_out {
    margin: 0 10px;
    width: 100%;
    margin: auto;
    page-break-after: always;
    h2,
    h4 {
      font-weight: normal;
    }
    .row {
      display: flex;
      flex-direction: row;
    }

    table {
      width: 100%;
      border: none;
      border-bottom: 1px solid #000;
      margin: 8px 0;
    }
    table tr {
      width: 100%;
      font-size: 10px;
    }
    table tr th {
      padding: 3px 5px;
    }
    table tr td {
      border: 1px solid #000;
      border-bottom: none;
      border-right: none;
      line-height: 18px;
      word-wrap: break-word;
      word-break: normal;
      max-width: 10px;
      padding: 3px 5px;
    }
    table tr td:first-child {
      max-width: 6px;
      word-wrap: break-word;
      word-break: normal;
    }
    table tr td:last-of-type,
    table tr th:last-of-type {
      border-right: 1px solid #000;
    }

    table tr th {
      border-top: 1px solid #000;
      border-left: 1px solid #000;
      height: 20px;
      line-height: 20px;
      font-size: 10px;
      font-weight: normal;
    }
    .font12 {
      font-size: 10px;
    }
  }

  @page {
    size: auto A4 landscape;
    margin: 5mm 15mm 5mm 5mm;
  }
</style>
